"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledMenuHeading = void 0;
var _MenuHeading = require("./MenuHeading");
// TODO: in v9, move styled() from MenuHeading.jsx to here
var StyledMenuHeading = _MenuHeading.MenuHeading;
exports.StyledMenuHeading = StyledMenuHeading;